import createFormSlice from '@/store/reducers/createFormSlice';
import { createSlice } from '@reduxjs/toolkit';
import { simulateSendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '../../api/apiConfig';
import { RegisterFormTypes } from '@/store/types/registerFormTypes';

const registerFormData: RegisterFormTypes = {
	email: '',
	password: '',
};

const formSlice = createFormSlice('registerForm', registerFormData);

const combinedSlice = createSlice({
	name: 'registerForm',
	initialState: formSlice.getInitialState(),
	reducers: {
		...formSlice.caseReducers,
	},
});

export const {
	resetSuccessMessage,
	setError,
} = combinedSlice.actions;

// API ещё не готов — заглушка с полным протоколом slice'а.
// Когда бэкенд сделает эндпоинт: simulateSendForm → sendForm (одно слово),
// контракт — в `src/store/types/registerFormTypes.ts`.
export const sendRegister = (data: RegisterFormTypes) => simulateSendForm(combinedSlice, API_ENDPOINTS.register, 'auth.register.success_message')(data);

export default combinedSlice.reducer;
export { combinedSlice as registerFormSlice };
